import { Row, Col, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

function SeccionEstudiosNee({
  formik,
  studiesList,
  lastStudiesList,
  nese,
  userOU,
}) {
  return (
    <>
      <Row className="mt-2">
        <Col md="4">
          <Label htmlFor="siguientesEstudios">
            <small>
              Estudios siguientes <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="siguientesEstudios"
            name="siguientesEstudios"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.siguientesEstudios}
            className={formik.errors.siguientesEstudios ? 'border border-danger error' : ''}
            disabled={userOU.centro === 'ORIENTACIÓN'}
          >
            {studiesList !== ''
              ? studiesList.map((option) => (
                  <option
                    key={`${option.Id_Estudio}-estudiosSiguientes`}
                    value={option.Estudio}
                  >
                    {option.Estudio_cast}
                  </option>
                ))
              : ''}
          </Input>
          {formik.errors.siguientesEstudios ? (
            <div className="text-danger tiny">{formik.errors.siguientesEstudios}</div>
          ) : null}
        </Col>
        <Col md="3">
          <Label htmlFor="formaAcceso">
            <small>
              Forma de acceso <span className="text-danger">*</span>
            </small>
          </Label>
          <Input
            id="formaAcceso"
            name="formaAcceso"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.formaAcceso}
            className={formik.errors.formaAcceso ? 'border border-danger error' : ''}
            disabled={userOU.centro === 'ORIENTACIÓN'}
          >
            {lastStudiesList !== ''
              ? lastStudiesList.map((option) => (
                  <option key={`${option.Id}-formaAccesso`} value={option.name}>
                    {option.name_cast}
                  </option>
                ))
              : ''}
          </Input>
          {formik.errors.formaAcceso ? (
            <div className="text-danger tiny">{formik.errors.formaAcceso}</div>
          ) : null}
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="3">
          <Label htmlFor="nee">
            <small>NESE</small>
          </Label>
          <Input
            id="nee"
            name="nee"
            type="select"
            onChange={formik.handleChange}
            value={formik.values.nee}
            disabled={userOU.centro === 'ORIENTACIÓN'}
            className={formik.errors.nee ? 'border border-danger error rounded ' : ''}
          >
            {nese !== ''
              ? nese.map((option) => (
                  <option key={`${option.Id}-sedeExamen`} value={option.tipo_cast}>
                    {option.tipo_cast}
                  </option>
                ))
              : ''}
          </Input>
          {formik.errors.nee ? (
            <div className="text-danger tiny">{formik.errors.nee}</div>
          ) : null}
        </Col>
        <Col md="7">
          <Label htmlFor="neeComment">
            <small>Comentario nese</small>
          </Label>
          <Input
            id="neeComment"
            name="neeComment"
            type="textarea"
            onChange={formik.handleChange}
            value={formik.values.neeComment}
            disabled={userOU.centro === 'ORIENTACIÓN'}
            className={formik.errors.neeComment ? 'border border-danger error rounded ' : ''}
          />
          {formik.errors.neeComment ? (
            <div className="text-danger tiny">{formik.errors.neeComment}</div>
          ) : null}
        </Col>
      </Row>
    </>
  );
}

SeccionEstudiosNee.propTypes = {
  formik: PropTypes.object.isRequired,
  studiesList: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  lastStudiesList: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  nese: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  userOU: PropTypes.object.isRequired,
};

export default SeccionEstudiosNee;
